import script from "./DocumentTemplatePayloadView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentTemplatePayloadView.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentTemplatePayloadView.vue?vue&type=style&index=0&id=5bc01424&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc01424"]])

export default __exports__